// removed by extract-text-webpack-plugin
module.exports = {"SectionRow":"_2TLVAhvk"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/section/section-row-layout.styles.scss
// module id = 213
// module chunks = 0